import comfort from '../../../assets/icons/comfort.svg'
import guarantee from '../../../assets/icons/guarantee.svg'
import prestige from '../../../assets/icons/prestige.svg'
import quality from '../../../assets/icons/quality.svg'

function advantages() {
  let data = [
  {
    id: 1,
    icon: guarantee,
    title: 'Гарантированный результат',
    text: 'Заметный эффект уже после первого сеанса подводного массажа благодаря сочетанию целебной силы воды и профессионализма наших специалистов.'
  },
  {
    id: 2,
    icon: quality,
    title: 'Безопасность и качество',
    text: 'Используем только сертифицированное оборудование и строго соблюдаем все санитарные нормы, обеспечивая максимальную безопасность и эффективность процедур.'
  },
  {
    id: 3,
    icon: comfort,
    title: 'Комплексный подход и комфорт',
    text: 'В нашей студии есть все для вашего комфорта: уютная атмосфера, индивидуальный подход и есть всё что необходимо для процедуры. Вам не придётся ни о чем беспокоиться!'
  },
  {
    id: 4,
    icon: prestige,
    title: 'Доступная роскошь',
    text: 'Мы предлагаем премиум-услугу санаторно-курортного типа по выгодным ценам, делая заботу о здоровье и красоте доступной каждому. Инвестируйте в себя с удовольствием!'
  },
]

  return (
    <div className='advantages'>
      {data.map(item => (
        <div key={item.id} className='advantages__item'>
          <img className='advantages__item-icon' src={item.icon} alt="Иконка" />
          <div className='advantages__item-title'>{item.title}</div>
          <div className='advantages__item-text'>{item.text}</div>
        </div>
      ))}
    </div>
   );
}

export default advantages;